function autoResize(el) {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight}px`;
}

/**
 * ダウンロードするWordファイルの見た目を画面上で近似したもの。
 * wordExport.jsのbuildConferenceWordBlobと同じ項目・並び順に合わせてある
 * （承認印欄だけは固定内容で確認の価値が低いためプレビューでは省略）。
 * 日時・場所以外の項目はここで直接編集できる（日時・場所はカレンダー／選択式の
 * 専用UIが別にあるため、プレビュー内では表示のみ）。
 */
export default function WordPreview({ meetingName, meta, onMetaChange, onNameBlur, itemOrder, items, onItemChange }) {
  return (
    <div className="word-preview-page">
      <h3 className="wp-title">会　議　報　告　書</h3>
      <p className="wp-reporter">
        <span>報告者　部署名：</span>
        <input
          className="wp-field wp-field-line"
          value={meta.department}
          onChange={(e) => onMetaChange('department', e.target.value)}
        />
      </p>
      <p className="wp-reporter">
        <span>氏　名：</span>
        <input
          className="wp-field wp-field-line"
          value={meta.name}
          onChange={(e) => onMetaChange('name', e.target.value)}
          onBlur={onNameBlur}
        />
      </p>

      <table className="wp-info-table">
        <tbody>
          <tr><th>会議名</th><td colSpan={3}>{meetingName}</td></tr>
          <tr><th>日時</th><td colSpan={3}>{meta.datetime}</td></tr>
          <tr><th>場所</th><td colSpan={3}>{meta.place}</td></tr>
          <tr>
            <th>進行</th>
            <td>
              <input className="wp-field wp-field-cell" value={meta.facilitator} onChange={(e) => onMetaChange('facilitator', e.target.value)} />
            </td>
            <th>記録</th>
            <td>
              <input className="wp-field wp-field-cell" value={meta.recorder} onChange={(e) => onMetaChange('recorder', e.target.value)} />
            </td>
          </tr>
          <tr>
            <th>参加者</th>
            <td colSpan={3}>
              <input className="wp-field wp-field-cell" value={meta.attendees} onChange={(e) => onMetaChange('attendees', e.target.value)} />
            </td>
          </tr>
        </tbody>
      </table>

      {itemOrder.map((label) => (
        <div className="wp-item" key={label}>
          <p className="wp-item-label">【{label}】</p>
          <textarea
            className="wp-item-textarea"
            value={items[label] || ''}
            placeholder="（該当なし）"
            ref={(el) => { if (el) autoResize(el); }}
            onChange={(e) => {
              onItemChange(label, e.target.value);
              autoResize(e.target);
            }}
          />
        </div>
      ))}
    </div>
  );
}
